<template>
  <v-app id="app_routes_list">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">ROUTE PLAN LISTS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Analyse the created route list using a variety of parameters.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <v-card-text class="custom_tool_bar_style">
          <v-btn class="custom_pdf_btn" variant="flat" size="large" @click="exportPDF">
            <v-icon size="large">mdi-file-pdf-box</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4" variant="flat" size="large" @click="exportExcel">
            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;EXCEL
          </v-btn>
        </v-card-text>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" md="6">
              <v-date-input
                v-model="assignDate"
                multiple="range"
                label="Select Date Range"
                placeholder="Select Date Range"
                variant="outlined"
                density="comfortable"
                append-inner-icon="mdi-close"
                prepend-inner-icon="$calendar"
                prepend-icon=""
                class="custom_input_field_color"
                @click:append-inner="clearAssignDate"
              ></v-date-input>

            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedRouteStatus"
                :items="routeCategoryOptions"
                label="Route Status"
                placeholder="Select route status"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                clearable
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row class="mt-0">
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="selectedProvinces"
                :items="provinceOptions"
                label="Area"
                placeholder="Select area"
                variant="outlined"
                density="comfortable"
                multiple
                class="custom_input_field_color"
                clearable
                :loading="areaLoading"
              >
                <template v-slot:selection="{ item, index }">
                  <div v-if="index === 0" class="d-flex align-center" style="gap: 8px; position: relative;">
                    <v-chip
                      color="#e7e7e7"
                      variant="flat"
                      class="custom-selection-chip text-black font-weight-medium"
                      size="small"
                      closable
                      @click:close="removeProvinceItem(item.value)"
                    >
                      {{ item.title }}
                    </v-chip>
                    
                    <div
                      v-if="selectedProvinces.length > 1"
                      class="hover-card-container"
                      @mouseenter="showProvinceHoverCard = true"
                      @mouseleave="showProvinceHoverCard = false"
                    >
                      <v-chip
                        color="#800080"
                        variant="flat"
                        class="custom-count-chip text-white font-weight-bold"
                        size="small"
                      >
                        +{{ selectedProvinces.length - 1 }}
                      </v-chip>
                      
                      <div v-if="showProvinceHoverCard" class="hover-card">
                        <div class="hover-card-list">
                          <div
                            v-for="province in selectedProvinces.slice(1)"
                            :key="province"
                            class="hover-card-item"
                          >
                            {{ province }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="selectedAgents"
                :items="agentOptions"
                item-title="displayName"
                item-value="id"
                label="Sales Rep"
                placeholder="Select sales rep name"
                variant="outlined"
                density="comfortable"
                multiple
                class="custom_input_field_color"
                clearable
                :loading="salesRepLoading"
              >
                <template v-slot:item="{ props, item }">
                  <v-list-item v-bind="props">
                    <v-list-item-title>
                      <span v-if="item.raw?.code" class="sales-rep-code-text">{{ item.raw.code }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </template>
<!--                 <template v-slot:selection="{ item, index }">-->
<!--                   <div v-if="index === 0" class="d-flex align-center" style="gap: 8px; position: relative;">-->
<!--                     <v-chip-->
<!--                       color="#e7e7e7"-->
<!--                       variant="flat"-->
<!--                       class="custom-selection-chip text-black font-weight-medium"-->
<!--                       size="small"-->
<!--                       closable-->
<!--                       @click:close="removeAgentItem(item.value)"-->
<!--                     >-->
<!--                      <span class="sales-rep-name-text">{{ item.raw?.name || item.title }}</span>-->
<!--                      <span v-if="item.raw?.code" class="sales-rep-code-text">{{ item.raw.code }}</span>-->
<!--                     </v-chip>-->

<!--                     <div-->
<!--                       v-if="selectedAgents.length > 1"-->
<!--                       class="hover-card-container"-->
<!--                       @mouseenter="showAgentHoverCard = true"-->
<!--                       @mouseleave="showAgentHoverCard = false"-->
<!--                     >-->
<!--                       <v-chip-->
<!--                         color="#800080"-->
<!--                         variant="flat"-->
<!--                         class="custom-count-chip text-white font-weight-bold"-->
<!--                         size="small"-->
<!--                       >-->
<!--                         +{{ selectedAgents.length - 1 }}-->
<!--                       </v-chip>-->

<!--                       <div v-if="showAgentHoverCard" class="hover-card">-->
<!--                         <div class="hover-card-list">-->
<!--                           <div-->
<!--                             v-for="agentId in selectedAgents.slice(1)"-->
<!--                             :key="agentId"-->
<!--                             class="hover-card-item"-->
<!--                           >-->
<!--                            {{ getAgentNameById(agentId) }}-->
<!--                           </div>-->
<!--                         </div>-->
<!--                       </div>-->
<!--                     </div>-->
<!--                   </div>-->
<!--                 </template>-->
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="searchQuery"
                label="Search"
                placeholder="Search"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-magnify"
                class="custom_input_field_color"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="mt-4 mb-4"></v-divider>

          <v-data-table
            :headers="headers"
            :items="filteredRoutes"
            :items-per-page="-1"
            :loading="loading"
            class="custom_table_normal"
            hide-default-footer
            hover
          >
            <template v-slot:[`item.area_code`]="{ item }">
              <span class="area-text">{{item.area_code || 'C117-COIN' }}</span>
            </template>

            <template v-slot:[`item.agent.name`]="{ item }">
              <div class="sales-rep-info">
                <div class="sales-rep-name">{{ item.agent?.name || getAgentNameFromId(item.saleRep_id) }}</div>
              </div>
            </template>

            <template v-slot:[`item.route_status`]="{ item }">
              <div class="route-status-card">
                <div class="status-rectangle" :class="getStatusClass(item.overallStatus)">
                  <span class="status-text">{{ item.route_status }}</span>
                </div>
                <!-- <div class="visited-date" v-if="item.lastVisitedDate">
                  {{ formatDate(item.lastVisitedDate) }}
                </div>
                <div class="visited-count ml-1 text-blue">
                  {{ getVisitedCount(item) }}
                </div> -->
              </div>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_routes_list">
                <template v-slot:activator="{ props }">
                  <v-btn
                    class="custom_btn_primary"
                    variant="flat"
                    size="large"
                    v-bind="props"
                  >
                    ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="permissions.read" @click="viewItem(item)">
                    <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                    <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>

          <div class="d-flex justify-space-between align-center mt-4" v-if="!loading">
            <div class="text-caption text-grey">
              Showing {{ paginationStart }} to {{ paginationEnd }} of {{ totalRecords }} entries
            </div>
            <v-pagination
              v-model="tablePage"
              :length="totalPages"
              :total-visible="7"
              @update:modelValue="handlePageChange"
            ></v-pagination>
            <div class="d-flex align-center">
              <span class="text-caption text-grey mr-2">Rows per page:</span>
              <v-select
                v-model="itemsPerPage"
                :items="[5, 10, 25, 50, 100]"
                variant="outlined"
                density="compact"
                style="width: 80px;"
                hide-details
                @update:modelValue="handlePerPageChange"
              ></v-select>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <v-dialog v-model="deleteDialog" id="app_routes_list" max-height="500" max-width="500" persistent>
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE DATA</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="deleteDialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this record ?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This record will be deleted immediately. Once deleted, it can no longer be used for any purpose.
                </p>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4">
                  <v-btn class="custom_btn_primary" @click="deleteItem">DELETE</v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="deleteDialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="view_Dialog" fullscreen id="app_routes_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')"
                     @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn style="background-color: #800080; color: white;" variant="flat" @click="view_Dialog = false">
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <RoutePlan/>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editDialog" fullscreen id="app_routes_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo_full_5.png')"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="custom_red_btn" variant="flat" @click="editDialog = false">
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <RoutePlanEdit/>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" :color="snackbarColor" location="top right" :timeout="3000">
        {{ snackbarMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import { EventBus } from '@/plugins/event-bus';
import RoutePlan from "@/components/RouteManagement/RoutePlan.vue";
import RoutePlanEdit from "@/components/RouteManagement/RoutePlanEdit.vue";
import { mapActions } from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getPermissions } from "@/plugins/permissions";
import * as XLSX from 'xlsx';

export default {
  name: "RoutesList",
  components: { RoutePlanEdit, RoutePlan },
  data() {
    return {
      selectedProvinces: [],
      provinceOptions: [],
      areaLoading: false,
      salesRepLoading: false,
      routeNameSearch: null,
      routeNameOptions: [],
      selectedAgents: [],
      agentOptions: [],
      searchQuery: '',
      tablePage: 1,
      itemsPerPage: 5,
      itemsPerPageOptions: [5, 10, 25, 50],
      totalRecords: 0,
      totalPages: 1,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      assignDate: null,
      deleteDialog: false,
      itemToDelete: null,
      view_Dialog: false,
      editDialog: false,
      selectedRouteStatus: [],
      routeCategoryOptions: ['Visited', 'Not Visited', 'Pending'],
      
      // Hover card states
      showRouteStatusHoverCard: false,
      showProvinceHoverCard: false,
      showAgentHoverCard: false,
      
      headers: [
        { title: 'AREA', key: 'area_code', align: 'start', sortable: true },
        { title: 'SALES REP CODE', key: 'agent.name', align: 'start', sortable: true },
        { title: 'ROUTE NAME', key: 'route_name', align: 'start', sortable: true },
        { title: 'ROUTE STATUS', key: 'route_status', align: 'start', sortable: false },
        { title: 'ASSIGN DATE', key: 'assign_date', align: 'start', sortable: true },
        { title: 'ACTIONS', key: 'action', align: 'start', sortable: false },
      ],
      routes: [],
      id: '',
      permissions: { read: true, write: true, delete: true },
      loading: false,
    };
  },

  methods: {
    ...mapActions(['updateSharedDataRoutes']),

    handlePageChange(page) {
      this.tablePage = page;
      this.fetchRoutes();
    },

    handlePerPageChange() {
      this.tablePage = 1;
      this.fetchRoutes();
    },

    fetchAreaCodes() {
      this.areaLoading = true;
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      if (!userId) {
        this.areaLoading = false;
        this.showSnackbar('User ID not found for areas', 'error');
        return;
      }
      const apiUrl = `${process.env.VUE_APP_API_BASE_URL}/api/area/user/${userId}`;

      axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.data.success) {
          const codes = Array.isArray(response.data.data) ? response.data.data : [];
          this.provinceOptions = [...new Set(codes.filter(Boolean))];
        } else {
          this.showSnackbar('Failed to fetch areas', 'error');
        }
      }).catch(error => {
        console.error('Error fetching areas:', error);
        this.showSnackbar('Error fetching areas: ' + (error.response?.data?.message || error.message), 'error');
      }).finally(() => {
        this.areaLoading = false;
      });
    },

    fetchSalesReps() {
      this.salesRepLoading = true;
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      if (!userId) {
        this.salesRepLoading = false;
        this.showSnackbar('User ID not found for sales reps', 'error');
        return;
      }
      const apiUrl = `${process.env.VUE_APP_API_BASE_URL}/api/getSalesRepByUserAreaCodes`;

      axios.get(apiUrl, {
        params: { userId: parseInt(userId) },
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.data.success) {
          const reps = response.data.data || [];
          this.agentOptions = reps.map(rep => ({
            id: rep.id,
            name: rep.salesRep_name || rep.user_name || `${rep.id}`,
            code: rep.userCode || '',
            displayName: rep.salesRep_name || rep.user_name || `${rep.id}`
          }));
        } else {
          this.showSnackbar('Failed to fetch sales reps', 'error');
        }
      }).catch(error => {
        console.error('Error fetching sales reps:', error);
        this.showSnackbar('Error fetching sales reps: ' + (error.response?.data?.message || error.message), 'error');
      }).finally(() => {
        this.salesRepLoading = false;
      });
    },

    clearAssignDate() {
      this.assignDate = null;
    },
    
    // Remove items methods
    removeRouteStatusItem(status) {
      this.selectedRouteStatus = this.selectedRouteStatus.filter(s => s !== status);
    },
    
    removeProvinceItem(province) {
      this.selectedProvinces = this.selectedProvinces.filter(p => p !== province);
    },
    
    removeAgentItem(agentId) {
      this.selectedAgents = this.selectedAgents.filter(id => id !== agentId);
    },

    getAgentNameById(agentId) {
      const agent = this.agentOptions.find(a => a.id === agentId);
      if (agent) {
        return agent.code ? `${agent.name} (${agent.code})` : agent.name;
      }
      const agentMap = {
        '1': 'John Doe',
        '2': 'Jane Smith',
        '3': 'Mike Johnson',
        '4': 'Sarah Williams',
        '5': 'David Brown'
      };
      return agentMap[agentId] || `${agentId}`;
    },

    getFieldValue(item, fieldPath) {
      return fieldPath.split('.').reduce((obj, key) => obj && obj[key], item);
    },

    getStatusClass(status) {
      switch(status) {
        case 'Visited':
          return 'status-visited';
        case 'Not Visited':
          return 'status-not-visited';
        case 'Pending':
          return 'status-pending';
        default:
          return '';
      }
    },

    getVisitedCount(route) {
      if (!route.dealers || route.dealers.length === 0) return "0/0";
      const total = route.dealers.length;
      const visited = route.dealers.filter(d => d.status === "Visited").length;
      return `${visited}/${total}`;
    },

    getLastVisitedDate(route) {
      if (!route.dealers || route.dealers.length === 0) return null;
      const visitedDealers = route.dealers.filter(d => d.status === "Visited");
      if (visitedDealers.length === 0) return null;
      
      // Get the most recent visited date
      const dates = visitedDealers.map(d => d.visited_date).filter(d => d);
      if (dates.length === 0) return null;
      
      return new Date(Math.max(...dates.map(d => new Date(d))));
    },

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    },

    formatDateForComparison(date) {
      if (!date) return null;

      // Keep backend date strings stable (no timezone conversion side effects).
      if (typeof date === 'string') {
        const trimmedDate = date.trim();
        const dateOnlyMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (dateOnlyMatch) return `${dateOnlyMatch[1]}-${dateOnlyMatch[2]}-${dateOnlyMatch[3]}`;

        const isoDateMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})T/);
        if (isoDateMatch) return `${isoDateMatch[1]}-${isoDateMatch[2]}-${isoDateMatch[3]}`;
      }

      const parsedDate = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(parsedDate.getTime())) return null;

      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const day = String(parsedDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    getSelectedDateRange() {
      if (!this.assignDate) return null;

      const selectedValues = (Array.isArray(this.assignDate) ? this.assignDate : [this.assignDate])
        .filter(Boolean)
        .map((date) => this.formatDateForComparison(date))
        .filter(Boolean);

      console.log('getSelectedDateRange selectedValues before sort:', selectedValues);

      if (selectedValues.length === 0) return null;

      // Sort dates lexicographically to ensure we have the correct start and end bounds
      selectedValues.sort();
      console.log('getSelectedDateRange selectedValues after sort:', selectedValues);

      return {
        start: selectedValues[0],
        end: selectedValues[selectedValues.length - 1]
      };
    },

    // Updated GET API integration - Using GET method with query parameters
    fetchRoutes() {
      this.loading = true;
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      
      const apiUrl = `${process.env.VUE_APP_API_BASE_URL}/api/route/v1/list`;
      
      const params = {
        userId: userId ? parseInt(userId) : 1,
        perPage: this.itemsPerPage,
        page: this.tablePage
      };

      const selectedDateRange = this.getSelectedDateRange();
      if (selectedDateRange) {
        params.fromDate = selectedDateRange.start;
        params.toDate = selectedDateRange.end;
      }

      if (this.selectedProvinces && this.selectedProvinces.length > 0) {
        params.area_code = this.selectedProvinces.join(',');
      }

      if (this.selectedAgents && this.selectedAgents.length > 0) {
        params.saleRep_ids = this.selectedAgents.join(',');
      }

      if (this.selectedRouteStatus && this.selectedRouteStatus.length > 0) {
        params.route_status = this.selectedRouteStatus;
      }

      if (this.searchQuery && this.searchQuery.trim() !== '') {
        params.searchQuery = this.searchQuery.trim();
      }

      axios.get(apiUrl, {
        params: params,
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.data.success) {
          const routesData = Array.isArray(response.data.data)
            ? response.data.data
            : (response.data.data?.data || []);

          const pagination = response.data.pagination || response.data.data?.pagination;
          if (pagination?.per_page) {
            this.itemsPerPage = Number(pagination.per_page);
          }
          if (pagination?.current_page) {
            this.tablePage = Number(pagination.current_page);
          }
          if (pagination?.total) {
            this.totalRecords = Number(pagination.total);
          } else {
            this.totalRecords = routesData.length;
          }
          if (pagination?.last_page) {
            this.totalPages = Number(pagination.last_page);
          } else if (this.totalRecords && this.itemsPerPage) {
            this.totalPages = Math.ceil(this.totalRecords / this.itemsPerPage);
          } else {
            this.totalPages = 1;
          }

          this.routes = routesData.map(route => ({
            ...route,
            dealers: route.dealers || [],
            agent: {
              id: route.saleRep_code ?? route.saleRep_id,
              name: this.getAgentNameFromId(route.saleRep_code ?? route.saleRep_id),
              registration_num: `${route.saleRep_code ?? route.saleRep_id}`
            },
            overallStatus: this.calculateOverallStatus(route),
            lastVisitedDate: this.getLastVisitedDate(route)
          }));

          console.log("Routes fetched successfully:", this.routes);
          this.extractFilterOptions(routesData);
        } else {
          this.showSnackbar('Failed to fetch routes', 'error');
        }
        this.loading = false;
      }).catch(error => {
        console.error('Error fetching routes:', error);
        this.showSnackbar('Error fetching routes: ' + (error.response?.data?.message || error.message), 'error');
        this.loading = false;
      });
    },

    getAgentNameFromId(saleRepId) {
      const agentMap = {
        '1': 'John Doe',
        '2': 'Jane Smith',
        '3': 'Mike Johnson',
        '4': 'Sarah Williams',
        '5': 'David Brown'
      };
      return agentMap[saleRepId] || `${saleRepId}`;
    },

    calculateOverallStatus(route) {
      const dealerStatuses = route.dealers?.map(d => d.status) || [];
      if (dealerStatuses.length === 0) return 'Pending';
      if (dealerStatuses.includes('Visited') && dealerStatuses.includes('PENDING')) {
        return 'Pending';
      }
      if (dealerStatuses.every(s => s === 'Visited')) {
        return 'Visited';
      }
      return 'Not Visited';
    },

    extractFilterOptions(routes) {
      // Extract unique route names
      const routeNames = [...new Set(routes.map(r => r.route_name).filter(Boolean))];
      this.routeNameOptions = routeNames;
    },

    confirmDelete(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },

    deleteItem() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      
      const apiUrl = `${process.env.VUE_APP_API_BASE_URL}/api/route/v1/delete/${this.itemToDelete.id}`;
      
      axios({
        method: 'delete',
        url: apiUrl,
        data: {
          userId: userId ? parseInt(userId) : 1
        },
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.data.success) {
          this.routes = this.routes.filter(r => r.id !== this.itemToDelete.id);
          this.deleteDialog = false;
          this.showSnackbar('Successfully Deleted.', 'success');
        } else {
          this.showSnackbar('Failed to delete route', 'error');
        }
      }).catch(error => {
        console.error('Error deleting route:', error);
        this.showSnackbar('Error deleting route: ' + (error.response?.data?.message || error.message), 'error');
      });
    },

    showSnackbar(message, color) {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    exportPDF() {
      const doc = new jsPDF();
      const tableData = this.filteredRoutes.map((item, i) => [
        i + 1, 
        item.area_code,
        item.agent?.name || `${item.saleRep_id}`,
        item.route_name, 
        item.overallStatus,
        this.getVisitedCount(item),
        item.assign_date
      ]);
      doc.autoTable({ 
        head: [['No.', 'Area', 'Agent', 'Route Name', 'Status', 'Visited Count', 'Assign Date']], 
        body: tableData,
        headStyles: { fillColor: [128, 0, 128] }
      });
      doc.save('Route_Details.pdf');
    },

    exportExcel() {
      // Prepare data for Excel
      const tableData = this.filteredRoutes.map((item, idx) => ({
        'NO': idx + 1,
        'Area': item.area_code || '',
        'Sales Rep': item.agent?.name || this.getAgentNameFromId(item.saleRep_id) || '',
        'Route Name': item.route_name || '',
        'Status': item.overallStatus || '',
        'Visited Count': this.getVisitedCount(item),
        'Assign Date': item.assign_date || ''
      }));

      // If no data, don't export
      if (tableData.length === 0) {
        this.showSnackbar('No data to export', 'warning');
        return;
      }

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(tableData);
      
      // Auto-size columns (optional - set column widths)
      const maxWidths = [];
      tableData.forEach(row => {
        Object.keys(row).forEach((key, idx) => {
          const cellValue = row[key] ? row[key].toString() : '';
          const width = Math.max(cellValue.length, key.length) + 2;
          if (!maxWidths[idx] || width > maxWidths[idx]) {
            maxWidths[idx] = Math.min(width, 50); // Cap at 50 characters
          }
        });
      });
      
      worksheet['!cols'] = maxWidths.map(w => ({ wch: w }));
      
      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Route Details');
      
      // Generate Excel file and download
      const excelFileName = 'Route Details.xlsx';
      XLSX.writeFile(workbook, excelFileName);
      
      this.showSnackbar('Excel file exported successfully!', 'success');
    },

    viewItem(item) {
      this.id = item.id;
      this.updateSharedDataRoutes(item);
      this.view_Dialog = true;
    },

    editItem(item) {
      this.id = item.id;
      this.updateSharedDataRoutes(item);
      this.editDialog = true;
    },

    backPageRoute() { 
      this.$router.push('/dashboard'); 
    },
    
    homeReload() {
      this.$router.push('/dashboard');
    },
    
    setupEventListeners() {
      EventBus.on('routeRecodeManagementButtonClick', () => { 
        this.view_Dialog = false; 
        this.editDialog = true; 
      });
      EventBus.on('routeRecodeManagementButtonClick2', () => { 
        this.view_Dialog = false; 
        this.fetchRoutes(); 
      });
    }
  },

  computed: {
    paginationStart() {
      if (this.totalRecords === 0) return 0;
      return (this.tablePage - 1) * this.itemsPerPage + 1;
    },
    
    paginationEnd() {
      const end = this.tablePage * this.itemsPerPage;
      return end > this.totalRecords ? this.totalRecords : end;
    },

    filteredRoutes() {
      if (!this.routes || this.routes.length === 0) return [];
      const selectedDateRange = this.getSelectedDateRange();

      return this.routes.filter((route) => {
        // Date filter - handles single day or range selection safely
        let matchesDate = true;
        if (selectedDateRange) {
          const routeDate = this.formatDateForComparison(route.assign_date);
          matchesDate = !!routeDate && routeDate >= selectedDateRange.start && routeDate <= selectedDateRange.end;
          console.log(`Route ID: ${route.id}, assign_date: ${route.assign_date}, routeDate: ${routeDate}, range: ${selectedDateRange.start} - ${selectedDateRange.end}, matchesDate: ${matchesDate}`);
        }
        
        // Status filter - FIXED: Handle array comparison correctly
        let matchesStatus = true;
        if (this.selectedRouteStatus && this.selectedRouteStatus.length > 0) {
          matchesStatus = this.selectedRouteStatus.includes(route.overallStatus);
        }
        
        // Province/Area filter - FIXED: Compare with correct field
        let matchesProvince = true;
        if (this.selectedProvinces && this.selectedProvinces.length > 0) {
          const routeArea = route.area_code ;
          matchesProvince = routeArea && this.selectedProvinces.includes(routeArea);
        }
        
        // Agent filter - FIXED: Convert to string for comparison
        let matchesAgent = true;
        if (this.selectedAgents && this.selectedAgents.length > 0) {
          const routeAgentId = route.saleRep_id ? parseInt(route.saleRep_id) : null;
          matchesAgent = routeAgentId && this.selectedAgents.includes(routeAgentId);
        }
        
        // Search filter - FIXED: Search in multiple fields
        let matchesSearch = true;
        if (this.searchQuery && this.searchQuery.trim() !== '') {
          const query = this.searchQuery.toLowerCase().trim();
          const routeName = (route.route_name || '').toLowerCase();
          const routeArea = (route.area_code || '').toLowerCase();
          const agentName = (route.agent?.name || this.getAgentNameFromId(route.saleRep_id) || '').toLowerCase();
          matchesSearch = routeName.includes(query) || routeArea.includes(query) || agentName.includes(query);
        }
        
        // Route name exact match filter - FIXED: Proper comparison
        let matchesRouteName = true;
        if (this.routeNameSearch && this.routeNameSearch !== null) {
          matchesRouteName = route.route_name === this.routeNameSearch;
        }

        return matchesDate && matchesStatus && matchesProvince && matchesAgent && matchesSearch && matchesRouteName;
      });
    }
  },

  watch: {
    assignDate() {
      this.tablePage = 1;
      this.fetchRoutes();
    },
    selectedProvinces() {
      this.tablePage = 1;
      this.fetchRoutes();
    },
    selectedAgents() {
      this.tablePage = 1;
      this.fetchRoutes();
    },
    selectedRouteStatus() {
      this.tablePage = 1;
      this.fetchRoutes();
    },
    searchQuery() {
      this.tablePage = 1;
      this.fetchRoutes();
    },
    tablePage() {
      this.fetchRoutes();
    },
    itemsPerPage() {
      this.tablePage = 1;
      this.fetchRoutes();
    }
  },

  mounted() {
    this.permissions = getPermissions(0, "Module Name");

    if (!this.permissions.read) {
      this.showSnackbar ? this.showSnackbar("Access Denied", "error") : alert("Access Denied");
      this.$router.push('/dashboard');
    }
    this.setupEventListeners();
    this.fetchAreaCodes();
    this.fetchSalesReps();
    this.fetchRoutes();
  },

  beforeUnmount() {
    EventBus.off('routeRecodeManagementButtonClick');
    EventBus.off('routeRecodeManagementButtonClick2');
  }
};
</script>

<style lang="scss" scoped>
  @use '../RouteManagement/RouteManagement.scss' as *;

  .sales-rep-code-text {
    color: #156CF7;
    font-weight: 600;
    margin-left: 6px;
  }
</style>

<style lang="scss">
#app_routes_list {
  .custom_page_main_title {
    font-size: 24px !important;
    font-weight: 900 !important;
    color: #4b5162 !important;
    margin-bottom: 4px;
    letter-spacing: 0.5px;
  }

  .custom_page_main_sub_title {
    font-size: 16px !important;
    color: #757575 !important;
  }

  .custom_tool_bar_style {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .divider-vertical {
    height: 40px;
    border-color: #bdbdbd !important;
    margin-right: 16px;
  }

  .gray-text {
    color: #757575 !important;
    font-weight: bold;
    letter-spacing: 1px;
  }

  .custom_card_box {
    font-family: var(--font-family) !important;
    border-top-left-radius: var(--border_top_left_radius) !important;
    border-top-right-radius: var(--border_top_right_radius) !important;
    border-bottom-right-radius: var(--border_bottom_right_radius) !important;
    box-shadow: 0px 4px 18px 0px #0000001F !important;
    background-color: #ffffff;
  }

  .custom_pdf_btn {
    background-color: #1152a3 !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    letter-spacing: 1px !important;
    border-radius: 2px !important;
    text-transform: uppercase !important;
  }

  .custom_excel_btn {
    background-color: #1F7B4D !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    letter-spacing: 1px !important;
    border-radius: 2px !important;
    text-transform: uppercase !important;
  }

  .custom_input_field_color {
    .v-field__input {
      color: #333333 !important;
    }
    
    :deep(.v-label) {
      font-size: 14px;
      font-weight: 500;
      color: #444;
    }
    
    :deep(.v-field__outline) {
      --v-field-border-opacity: 0.25;
    }
  }

  .custom_table_normal {
    border-top: 1px solid #e0e0e0;
    margin-top: 10px;

    :deep(thead th) {
      font-weight: bold !important;
      color: #616161 !important;
      background-color: #fafafa !important;
      text-transform: uppercase;
      font-size: 13px !important;
      border-bottom: 2px solid #EEEEEE !important;
    }
    
    :deep(.v-data-table__td) {
      border-bottom: 1px solid #F0F0F0 !important;
    }
  }

  .area-text {
    font-weight: normal !important;
    font-size: 14px;
    color: #555;
  }

  .sales-rep-info {
    .sales-rep-name {
      font-weight: normal !important;
      font-size: 14px;
      color: #555;
    }
    
    .sales-rep-reg {
      font-size: 11px;
      color: #888;
      margin-top: 2px;
    }
  }

  .custom_btn_primary {
    background-color: #800080 !important;
    color: #ffffff !important;
    font-weight: bold;
    letter-spacing: 1px;
    border-radius: 2px;
  }

  .custom_btn_secondary {
    background-color: #e0e0e0 !important;
    color: #424242 !important;
    font-weight: bold;
    letter-spacing: 1px;
    border-radius: 4px;
  }

  .custom_red_btn {
    background-color: #d32f2f !important;
    color: #ffffff !important;
    font-weight: bold;
    border-radius: 4px;
  }

  .custom_font_color_view {
    color: #156CF7 !important;
    font-weight: bold;
  }

  .custom_font_color_edit {
    color: #2A8200 !important;
    font-weight: bold;
  }

  .custom_font_color_delete {
    color: #BB0000 !important;
    font-weight: bold;
  }

  .custom_company_logo_nav {
    width: 110px;
    height: 35px;
  }

  .custom_fullscreen_dialog_toolbar {
    position: fixed !important;
    z-index: 999999 !important;
  }

  .custom_scroll_option_fullscreen_dialog {
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
  }

  .route-status-card {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 4px 0;
  }

  .status-rectangle {
    display: inline-block;
    padding: 6px 12px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    min-width: 100px;
    
    .status-text {
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  .status-visited {
    background-color: #E8F5E9;
    color: #2E7D32;
    border: 1px solid #C8E6C9;
  }

  .status-not-visited {
    background-color: #FFEBEE;
    color: #C62828;
    border: 1px solid #FFCDD2;
  }

  .status-pending {
    background-color: #FFF3E0;
    color: #EF6C00;
    border: 1px solid #FFE0B2;
  }

  .visited-date {
    font-size: 11px;
    color: #666;
    font-weight: 500;
  }

  .visited-count {
    font-size: 13px;
    font-weight: 700;
    color: #333;
  }

  :deep(.v-field__prepend-inner) {
    display: none !important;
  }

  .custom-selection-chip {
    max-width: 200px;
    padding: 0 12px !important;
    font-size: 13px !important;
    transition: all 0.2s ease-in-out !important;
    
    &:hover {
      background-color: #d5d5d5 !important;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    
    :deep(.v-chip__close) {
      opacity: 0.6;
      transition: opacity 0.2s;
      
      &:hover {
        opacity: 1;
      }
    }
  }

  .custom-count-chip {
    min-width: 40px;
    padding: 0 10px !important;
    font-size: 13px !important;
    transition: all 0.2s ease-in-out !important;
    background: linear-gradient(135deg, #800080 0%, #9b2e9b 100%) !important;
    
    &:hover {
      background: linear-gradient(135deg, #6a006a 0%, #800080 100%) !important;
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(128, 0, 128, 0.3);
      cursor: pointer;
    }
    
    &:active {
      transform: translateY(0);
    }
  }

  .hover-card-container {
    position: relative;
    display: inline-block;
  }

  .hover-card {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 8px;
    min-width: 200px;
    max-width: 300px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 9999;
    background-color: white !important;
    border: 1px solid #ddd !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
    
    .hover-card-list {
      background-color: white;
      padding: 8px 0;
    }
    
    .hover-card-item {
      padding: 10px 16px;
      color: #333;
      font-size: 13px;
      font-weight: 500;
      border-bottom: 1px solid #f0f0f0;
      background-color: white;
      
      &:last-child {
        border-bottom: none;
      }
      
      &:hover {
        background-color: #f5f5f5;
      }
    }
  }

  .hover-card::-webkit-scrollbar {
    width: 6px;
  }

  .hover-card::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .hover-card::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
    
    &:hover {
      background: #a8a8a8;
    }
  }

  .sales-rep-name-text {
    color: #333;
  }

  .sales-rep-code-text {
    color: #156CF7;
    font-weight: 600;
    margin-left: 6px;
  }
}
</style>


